import { render, staticRenderFns } from "./roomCreatePayFeeList.vue?vue&type=template&id=ca084f26&scoped=true"
import script from "./roomCreatePayFeeList.vue?vue&type=script&lang=js"
export * from "./roomCreatePayFeeList.vue?vue&type=script&lang=js"
import style0 from "./roomCreatePayFeeList.vue?vue&type=style&index=0&id=ca084f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca084f26",
  null
  
)

export default component.exports